import React from "react";

export const ErrorPage: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-bg-subtle select-none">
      <span className="font-mono text-[120px] leading-none font-semibold text-fg-bold tracking-tight">
        500
      </span>
      <p className="mt-4 text-base text-fg-medium">
        Something broke. We're already patching it up!
      </p>
      <button
        onClick={() => window.location.reload()}
        className="mt-8 px-4 py-2 text-xs font-medium text-fg-bold bg-bg border border-border rounded-sm hover:bg-bg-hover transition-colors duration-100 cursor-pointer"
      >
        Reload page
      </button>
    </div>
  );
};
